import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateListPickerJson(listPickerJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // ListPickerJson => RichAssetListPicker => RichAsset => Node
    const parentNode = listPickerJson?.$container?.$container
        ?.$container;
    const idField = getId(parentNode);
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: listPickerJson,
        allProperties: listPickerJson.properties,
        requiredProperties: [
            ast.TypeStaticProperty,
            ast.ListPickerOptionsArrayProperty,
        ],
        parentNode,
        accept,
    });
    const optionsArray = listPickerJson.properties.find((prop) => {
        return ast.isListPickerOptionsArrayProperty(prop);
    });
    // Each listpicker option in the options array has an optional image
    // and alt_text property. We want to ensure that either all the options have
    // these properties defined, or none of the options have them.
    let optionsCountWithImage = 0;
    let optionsCountWithoutImage = 0;
    let optionsCountWithAltText = 0;
    let optionsCountWithoutAltText = 0;
    optionsArray?.options?.forEach((option) => {
        const imageProperty = option.properties.find((p) => ast.isImageProperty(p));
        if (imageProperty) {
            optionsCountWithImage++;
        }
        else {
            optionsCountWithoutImage++;
        }
        const altTextProperty = option.properties.find((p) => ast.isAltTextProperty(p));
        if (altTextProperty) {
            optionsCountWithAltText++;
        }
        else {
            optionsCountWithoutAltText++;
        }
    });
    if (optionsCountWithImage !== 0 && optionsCountWithoutImage !== 0) {
        accept('error', `Use of image property in the options is not consistent.`, {
            node: listPickerJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
    if (optionsCountWithAltText !== 0 && optionsCountWithoutAltText !== 0) {
        accept('error', `Use of alt_text property in the options is not consistent.`, {
            node: listPickerJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
}
export function validateListPickerOption(listPickerOption, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // ListPickerOption => ListPickerOptionsArrayProperty => ListPickerJson => RichAssetListPicker => RichAsset => Node
    const parentNode = listPickerOption?.$container?.$container?.$container
        ?.$container?.$container;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: listPickerOption,
        allProperties: listPickerOption.properties,
        requiredProperties: [ast.LabelProperty, ast.DestProperty],
        parentNode,
        accept,
    });
}
//# sourceMappingURL=list-picker.js.map